(() => {
  window.swinger.observer.initialize('.swinger-video-placeholder', (elem) => {
    elem.addEventListener('canplay', (e) => {
      const player = e.detail.plyr;

      player.play();
    });
  }, false);
})();
